/**
 * MELANUA Toast Notification Component
 * Displays temporary notifications for cart actions
 */

import React, { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose?.();
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const bgColor = type === 'error'
        ? 'bg-red-50 border-red-200 text-red-700'
        : 'bg-champagne/20 border-champagne-gold/30 text-charcoal';

    const iconColor = type === 'error' ? 'text-red-500' : 'text-champagne-gold';

    return (
        <div className="fixed bottom-6 right-6 z-[60] animate-slide-up">
            <div className={`flex items-center gap-3 px-5 py-4 rounded-2xl border shadow-lg ${bgColor}`}>
                {type === 'success' ? (
                    <svg className={`w-5 h-5 ${iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                ) : (
                    <svg className={`w-5 h-5 ${iconColor}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                )}
                <span className="font-medium">{message}</span>
                <button
                    onClick={onClose}
                    className="ml-2 text-charcoal/40 hover:text-charcoal transition-colors"
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>
    );
}
